import { useNavigation } from '@react-navigation/native';
import { useCallback, useMemo, useState } from 'react';
import { Pressable, View } from 'react-native';
import { Text } from '@/components/Text';
import encryptedStorage from '@/stores/encryptedStorage';

// constants
import { ablenkerConfig, imagesConfig } from './constants';

// styles
import SquareGrid from '@/components/Util/reactSquareGrid';
import { styles } from './styles';
import React from 'react';
import { SelectLayout } from '@/components/SelectLayout';
import { ExerciseCard } from '@/screens/Aufgaben/ExerciseCard';
import { AblenkerRadio } from './AblenkerRadio';
import { Icon } from '@/components/Icon';
import { Divider } from 'react-native-elements';
import theme from '@/config/theme';
import { logError } from '@/utils/logHandling';

export function BildKarten(props) {
  const { route } = props;
  const { navigate } = useNavigation();
  const { setId, exerciseClass, cardSettings } = route.params ?? {};
  const [cardSettingsState, setCardSettingsState] = useState(cardSettings);

  const changeLocalSetCardSettings = useCallback(async (setId, name, value) => {
    let localState;
    localState = await encryptedStorage().getItem(setId);
    localState.cardSettings[name] = value;
    await encryptedStorage().setItem(setId, { ...localState });
    setCardSettingsState((prev) => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  const onCardSettingsValueChange = useCallback((name, value) => {
    changeLocalSetCardSettings(setId, name, value);
  }, []);

  const onBildOrAblenkerPress = useCallback((name, value) => {
    return () => {
      onCardSettingsValueChange(name, value);
    };
  }, []);

  const onStartPress = useCallback(async () => {
    try {
      const foundSet = await encryptedStorage().getItem(setId);
      navigate('BildKartenExercise', { setId, exerciseClass, foundSet });
    } catch (error) {
      logError('Could not start exercise ', error);
    }
  }, []);

  const renderBilders = useMemo(() => {
    return imagesConfig.map((imageConf) => {
      let isActive = cardSettingsState?.images === imageConf.value;
      return (
        <ExerciseCard
          isActive={isActive}
          label={imageConf.title}
          iconName={imageConf.iconName}
          onPress={onBildOrAblenkerPress('images', imageConf.value)}
        />
      );
    });
  }, [cardSettingsState?.images]);

  const renderAblenker = useMemo(() => {
    return ablenkerConfig.map((ablenker, index, items) => {
      const isActive = cardSettingsState?.setting === ablenker.value;
      return (
        <React.Fragment key={index}>
          <Pressable
            style={styles.ablenkerRow}
            onPress={onBildOrAblenkerPress('setting', ablenker.value)}
          >
            <Text style={styles.ablenkerLabel}>{ablenker.title}</Text>
            {isActive ? (
              <Icon
                name="checkboxCircleMarked"
                size={theme.fontSizes['3xl']}
                color={theme.colors.primary}
              />
            ) : (
              <Icon
                name="checkboxCircleUnmarked"
                size={theme.fontSizes['3xl']}
                color={theme.colors.primary}
              />
            )}
          </Pressable>
          {items.length - 1 !== index && (
            <Divider color={theme.colors.grey} width={2} />
          )}
        </React.Fragment>
      );
    });
  }, [cardSettingsState?.setting]);

  return (
    <View style={styles.container}>
      <SelectLayout
        leftGrid={<SquareGrid items={renderBilders} rows={2} columns={2} />}
        rightGrid={
          <AblenkerRadio onStartPress={onStartPress}>
            <View style={styles.innerList}>{renderAblenker}</View>
          </AblenkerRadio>
        }
      />
    </View>
  );
}
